import { render, staticRenderFns } from "./container.vue?vue&type=template&id=5be34fa4&scoped=true&lang=pug"
import script from "./container.vue?vue&type=script&lang=coffee"
export * from "./container.vue?vue&type=script&lang=coffee"
import style0 from "./container.vue?vue&type=style&index=0&id=5be34fa4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be34fa4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LayoutNotificationBar: require('/opt/build/repo/site/components/layout/notification-bar/bar.vue').default})
